import { render } from "./Partner.vue?vue&type=template&id=9cac70b0&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"

import "./Partner.vue?vue&type=style&index=0&id=9cac70b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cac70b0"]])

export default __exports__